import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ui from 'redux-ui';
import { connect } from 'react-redux';
import ListView from 'components/ListView';
import MessageBox from 'components/MessageBox';
import EstimatorCard from './components/estimatorCard';
import { requestEstimatorList } from 'actionCreators';
import {
  getEstimatorList,
  getEstimatorHasNextPage,
  getEstimatorLoading,
  getWorkroomFilteredByIds,
} from '../../../../reducers';

class EstimatorList extends Component {
  componentDidMount = () => this.props.requestEstimatorList();

  componentWillUnmount = () => this.props.updateUI('successMessage', '');

  handleInfiniteLoad = () =>
    (this.props.needsMore && !this.props.loading ? this.props.requestEstimatorList() : null);

  render = () => {
    const { estimators, loading, needsMore, workroomsByEstimator } = this.props;
    return (<div>
      {this.props.ui.successMessage ? <MessageBox
        message={this.props.ui.successMessage}
      /> : null}
      <ListView
        loading={loading}
        needsMore={needsMore}
        handleInfiniteLoad={this.handleInfiniteLoad}
      >
        {estimators.map(estimator => (<EstimatorCard
          key={estimator.id}
          estimator={estimator}
          workrooms={workroomsByEstimator[estimator.id]}
        />))}
      </ListView>
    </div>);
  }
}

EstimatorList.propTypes = {
  ui: PropTypes.object,
  loading: PropTypes.bool,
  needsMore: PropTypes.bool,
  workroomsByEstimator: PropTypes.object,
  estimators: PropTypes.array,
  updateUI: PropTypes.func,
  dispatch: PropTypes.func,
  requestEstimatorList: PropTypes.func,
};

const mapStateToProps = (state) => {
  const estimators = getEstimatorList(state);
  const loading = getEstimatorLoading(state);
  const workroomsByEstimator = estimators.reduce((acc, current) => {
    const workroomIds = current.workrooms || [];
    return { ...acc, [current.id]: getWorkroomFilteredByIds(state)(workroomIds) };
  }, {});
  return {
    loading,
    estimators,
    workroomsByEstimator,
    needsMore: getEstimatorHasNextPage(state),
  };
};

export default ui()(connect(mapStateToProps, { requestEstimatorList })(EstimatorList));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/estimators/estimatorList.jsx